module.exports = __webpack_public_path__ + "static/media/kill.b4340af7.jpg";